// extracted by mini-css-extract-plugin
module.exports = {"w195a7op":"w195a7op","fadeIn":"fadeIn"};